export default __webpack_public_path__ + "static/rsz_ibany-0bd23987b8cf81718d0a0aff75dc7f59.jpg";